import React from 'react';

const PlainButton = React.forwardRef((props, ref) => {
    const {style, children, onClick, btnRef, className, disabled, ..._props} = props;
    let _style = {display: 'inline', cursor: 'pointer', ...style};
    let clickProps = {
        onClick: (e) => {
            !disabled && onClick?.(e);
        },
        onKeyPress: (e) => {
            if(disabled) {
                return;
            }
            const code = e.which;
            // 13 = Return, 32 = Space
            if ((code === 13) || (code === 32)) {
                onClick?.(e);
            }
        }
    };
    return <div role="button" ref={ref} style={_style}  aria-disabled={!!disabled} className={`tde-btn-plain${disabled? ' tde-disabled': ""} ${className || ''}`} {..._props} {...clickProps} tabIndex={0}>{children}</div>
});

export default PlainButton;
